import React, { useRef } from 'react';
import Icon from '../../../components/AppIcon';

import { pdfService } from '../../../services/pdfService';

const PDFUploadPanel = ({ onUpload, pdfFile }) => {
  const fileInputRef = useRef(null);

  const handleFileSelect = (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    // Validate PDF
    const validation = pdfService?.validatePDF(file);
    if (!validation?.valid) {
      alert(validation?.error);
      return;
    }

    onUpload(file);
  };

  const handleButtonClick = () => {
    fileInputRef?.current?.click();
  };

  return (
    <div className="card p-6 mb-6">
      <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Upload" size={20} className="text-primary" />
        Cargar PDF
      </h3>
      <div className="space-y-4">
        <div 
          className="border-2 border-dashed border-border rounded-lg p-8 text-center hover:border-primary transition-colors cursor-pointer"
          onClick={handleButtonClick}
        >
          <Icon name="FileUp" size={48} className="text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground mb-2">
            Haz clic para seleccionar un PDF
          </p>
          <p className="text-xs text-muted-foreground">
            Máximo 10MB • Solo archivos PDF
          </p>
        </div>

        <input
          ref={fileInputRef}
          type="file"
          accept=".pdf,application/pdf"
          onChange={handleFileSelect}
          className="hidden"
        />

        {pdfFile && (
          <div className="p-3 bg-success/10 border border-success rounded-lg">
            <div className="flex items-start gap-3">
              <Icon name="FileCheck" size={20} className="text-success flex-shrink-0 mt-0.5" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-success truncate">
                  {pdfFile?.name}
                </p>
                <p className="text-xs text-success/70 mt-1">
                  {(pdfFile?.size / 1024 / 1024)?.toFixed(2)} MB
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="pt-4 border-t border-border">
          <h4 className="text-sm font-semibold text-foreground mb-2">Instrucciones:</h4>
          <ul className="text-xs text-muted-foreground space-y-1">
            <li className="flex items-start gap-2">
              <Icon name="Check" size={14} className="flex-shrink-0 mt-0.5" />
              <span>Carga un plano en formato PDF</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Check" size={14} className="flex-shrink-0 mt-0.5" />
              <span>Usa el botón "Analizar con IA" para detectar lotes automáticamente</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Check" size={14} className="flex-shrink-0 mt-0.5" />
              <span>Edita los lotes detectados</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Check" size={14} className="flex-shrink-0 mt-0.5" />
              <span>Guarda el plano final</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PDFUploadPanel;